export const Education = {
  DEGREES: {
    AA: 'AA',
    AS: 'AS',
    BA: 'BA',
    BCL: 'BCL',
    BS: 'BS',
    BSC: 'BSc',
    BVC: 'BVC',
    DIPLJUR: 'Dipl.Jur.',
    DIPLWIJUR: 'Dipl.-Wi.Jur.',
    DRJUR: 'Dr.Jur.',
    FSE: 'First State Exam',
    GDL: 'GDL',
    JD: 'JD',
    LLB: 'LLB',
    LLM: 'LLM',
    LPC: 'LPC',
    PCLL: 'PCLL',
    MA: 'MA',
    MAGJUR: 'Mag.Jur.',
    MBA: 'MBA',
    MD: 'MD',
    MLIS: 'MLIS',
    MS: 'MS',
    MSC: 'MSc',
    PGCERT: 'PGCert',
    PGDIP: 'PGDip',
    PharmD: 'PharmD',
    PHD: 'PHD',
    QLTS: 'QLTS',
    SQE1: 'SQE1',
    SQE2: 'SQE2',
    SSE: 'Second State Exam',
  },
  LAW_DEGREES: {
    BCL: 'BCL',
    BVC: 'BVC',
    DIPLJUR: 'Dipl.Jur.',
    DIPLWIJUR: 'Dipl.-Wi.Jur.',
    JD: 'JD',
    LLB: 'LLB',
    LLM: 'LLM',
    LPC: 'LPC',
  },
  /** field names */
  CANDIDATE_ID: 'candidateId',
  CREATED_AT: 'createdAt',
  DEGREE: 'degree',
  INSTITUTION: 'institution',
  STATE_EXAM_SCORE: 'stateExamScore',
  YEAR_AWARDED: 'yearAwarded',
  ID: 'id',
  UPDATED_AT: 'updatedAt',
} as const;
